import classNames from 'classnames'
import React, { useState, useRef } from 'react'
import { isMobile } from 'react-device-detect'

const TooltipIcon = ({
  tone,
  index,
  tonRefs,
  toneTooltip,
  handleMouseOver,
  handleMouseLeave,
  className,
}: any) => {
  return (
    <>
      <span className=" flex items-center">
        <svg
          className="w-[24px] h-[24px]" // Tailwind CSS for width and height
          viewBox="0 0 36 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          onClick={() => handleMouseOver(index)}
          ref={(el) => (tonRefs.current[index] = el)}
        >
          <path
            d="M28.6875 3.375H7.3125C5.9703 3.37649 4.6835 3.91034 3.73442 4.85942C2.78534 5.8085 2.25149 7.0953 2.25 8.4375V21.9375C2.25149 23.2797 2.78534 24.5665 3.73442 25.5156C4.6835 26.4647 5.9703 26.9985 7.3125 27H9V31.5C8.99994 31.7139 9.06087 31.9234 9.17564 32.1039C9.2904 32.2844 9.45425 32.4285 9.64798 32.5192C9.8417 32.6099 10.0573 32.6435 10.2694 32.616C10.4815 32.5885 10.6815 32.5012 10.8457 32.3641L17.2786 27H28.6875C30.0297 26.9985 31.3165 26.4647 32.2656 25.5156C33.2147 24.5665 33.7485 23.2797 33.75 21.9375V8.4375C33.7485 7.0953 33.2147 5.8085 32.2656 4.85942C31.3165 3.91034 30.0297 3.37649 28.6875 3.375ZM11.25 17.4375C10.805 17.4375 10.37 17.3055 9.99997 17.0583C9.62996 16.8111 9.34157 16.4597 9.17127 16.0485C9.00097 15.6374 8.95642 15.185 9.04323 14.7485C9.13005 14.3121 9.34434 13.9112 9.65901 13.5965C9.97368 13.2818 10.3746 13.0675 10.811 12.9807C11.2475 12.8939 11.6999 12.9385 12.111 13.1088C12.5222 13.2791 12.8736 13.5675 13.1208 13.9375C13.368 14.3075 13.5 14.7425 13.5 15.1875C13.5 15.7842 13.2629 16.3565 12.841 16.7785C12.419 17.2004 11.8467 17.4375 11.25 17.4375ZM18 17.4375C17.555 17.4375 17.12 17.3055 16.75 17.0583C16.38 16.8111 16.0916 16.4597 15.9213 16.0485C15.751 15.6374 15.7064 15.185 15.7932 14.7485C15.88 14.3121 16.0943 13.9112 16.409 13.5965C16.7237 13.2818 17.1246 13.0675 17.561 12.9807C17.9975 12.8939 18.4499 12.9385 18.861 13.1088C19.2722 13.2791 19.6236 13.5675 19.8708 13.9375C20.118 14.3075 20.25 14.7425 20.25 15.1875C20.25 15.7842 20.0129 16.3565 19.591 16.7785C19.169 17.2004 18.5967 17.4375 18 17.4375ZM24.75 17.4375C24.305 17.4375 23.87 17.3055 23.5 17.0583C23.13 16.8111 22.8416 16.4597 22.6713 16.0485C22.501 15.6374 22.4564 15.185 22.5432 14.7485C22.63 14.3121 22.8443 13.9112 23.159 13.5965C23.4737 13.2818 23.8746 13.0675 24.311 12.9807C24.7475 12.8939 25.1999 12.9385 25.611 13.1088C26.0222 13.2791 26.3736 13.5675 26.6208 13.9375C26.868 14.3075 27 14.7425 27 15.1875C27 15.7842 26.7629 16.3565 26.341 16.7785C25.919 17.2004 25.3467 17.4375 24.75 17.4375Z"
            fill="#2E343D"
            className="hover:fill-main"
          />
        </svg>
      </span>
      {toneTooltip[index] && (
        <div
          className={classNames(
            ' flex flex-col p-[16px] md:p-[26px] gap-[10px] bg-white  h-auto  border-[3px] border-main  rounded-[20px] fixed  z-50',
            {
              'w-[330px] z-50 ': !className,
              [className]: className,
              'bottom-[35%] right-[42%]': !isMobile,
              'bottom-[35%] left-5': isMobile,
            }
          )}
        >
          <div className="flex items-center justify-between z-50">
            <p className="font-bold text-[18px] text-left ">{tone?.name}</p>
            <button type="button" onClick={() => handleMouseLeave(index)}>
              <img
                src="assets/img/Icon_x.png"
                alt="icon_x"
                height={24}
                width={24}
              />
            </button>
          </div>
          <div>
            <p className="text-left">{tone?.description}</p>
          </div>
        </div>
      )}
    </>
  )
}

export default TooltipIcon
